var _effectorFileName = "/src/page-content/home/components/how-we-work/how-we-work.tsx";
import { HOW_WE_WORK_FOR_COMPANIES } from '@/widgets/layouts/main/constants/help-achieve-goals-lists';
import { Article } from '@/shared/components/article';
import { LineWithCircles } from '@/shared/components/line-with-circles';
export const HowWeWork = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Work Plan:</h2>

      <LineWithCircles>
        {HOW_WE_WORK_FOR_COMPANIES.map((bulletPoint, index) => {
        return <div key={index}>
              <h3 className="mb-3 header-h3 sm:mb-5">{bulletPoint.title}</h3>

              <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{
            __html: bulletPoint.description
          }} />
            </div>;
      })}
      </LineWithCircles>
    </Article>;
};